import { Component } from "@mzw/component";
import { getVisibleElements } from "@mzw/utils";

export class ProductCardGallery extends Component {
	static tagName = "product-card-gallery";
	static {
		customElements.define(ProductCardGallery.tagName, ProductCardGallery);
	}

	requiredRefs = ["gallery"];

	get items() {
		return [...this.refs.gallery.children];
	}

	connectedCallback() {
		super.connectedCallback();
		if (this.closest("slider-component")) return this.setAttribute("disabled", "");
		this.addEventListener("pointerenter", this.#onPointerEnter);
	}

	disconnectedCallback() {
		super.disconnectedCallback();
		this.removeEventListener("pointerenter", this.#onPointerEnter);
	}

	#onPointerEnter = () => {
		const lazyImages = this.querySelectorAll("[loading='lazy']");
		for (const img of lazyImages) {
			img.removeAttribute("loading");
		}
	};

	next(event) {
		event?.preventDefault();
		const visibleElements = getVisibleElements(this.refs.gallery, this.items, 0.5, "x");
		const inViewItem = visibleElements[0];
		if (inViewItem) {
			const nextElement = inViewItem.nextElementSibling ?? this.items[0];
			nextElement.scrollIntoView({
				behavior: "smooth",
				inline: "start",
				block: "nearest",
			});
		}
	}

	previous(event) {
		event?.preventDefault();
		const visibleElements = getVisibleElements(this.refs.gallery, this.items, 0.5, "x");
		const inViewItem = visibleElements[0];
		if (inViewItem) {
			const prevElement = inViewItem.previousElementSibling ?? this.items.at(-1);
			prevElement.scrollIntoView({
				behavior: "smooth",
				inline: "start",
				block: "nearest",
			});
		}
	}
}
